// package: user
// file: apigateway/user/user.proto

import * as apigateway_user_user_pb from "../../apigateway/user/user_pb";
export class UserService {
  static serviceName = "user.UserService";
}
export namespace UserService {
  export class UpdateLastLogin {
    static readonly methodName = "UpdateLastLogin";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.UpdateLastLoginRequest;
    static readonly responseType = apigateway_user_user_pb.UpdateLastLoginReply;
  }
  export class GetCallStatus {
    static readonly methodName = "GetCallStatus";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.GetCallStatusRequest;
    static readonly responseType = apigateway_user_user_pb.GetCallStatusReply;
  }
  export class GetBlackList {
    static readonly methodName = "GetBlackList";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.GetBlackListRequest;
    static readonly responseType = apigateway_user_user_pb.GetBlackListReply;
  }
  export class GetBloggerRegistrationStatus {
    static readonly methodName = "GetBloggerRegistrationStatus";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.GetBloggerRegistrationStatusRequest;
    static readonly responseType = apigateway_user_user_pb.GetBloggerRegistrationStatusReply;
  }
  export class GetInvite {
    static readonly methodName = "GetInvite";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.GetInviteRequest;
    static readonly responseType = apigateway_user_user_pb.GetInviteReply;
  }
  export class GetInviteConstants {
    static readonly methodName = "GetInviteConstants";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.GetInviteConstantsRequest;
    static readonly responseType = apigateway_user_user_pb.GetInviteConstantsReply;
  }
  export class GetIsUniqueUsername {
    static readonly methodName = "GetIsUniqueUsername";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.GetIsUniqueUsernameRequest;
    static readonly responseType = apigateway_user_user_pb.GetIsUniqueUsernameReply;
  }
  export class GetSmsCertificationPhoneNumber {
    static readonly methodName = "GetSmsCertificationPhoneNumber";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.GetSmsCertificationPhoneNumberRequest;
    static readonly responseType = apigateway_user_user_pb.GetSmsCertificationPhoneNumberReply;
  }
  export class GetSmsCertificationStatus {
    static readonly methodName = "GetSmsCertificationStatus";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.GetSmsCertificationStatusRequest;
    static readonly responseType = apigateway_user_user_pb.GetSmsCertificationStatusReply;
  }
  export class GetEmailAddress {
    static readonly methodName = "GetEmailAddress";
    static readonly service = UserService;
    static readonly requestStream = false;
    static readonly responseStream = false;
    static readonly requestType = apigateway_user_user_pb.GetEmailAddressRequest;
    static readonly responseType = apigateway_user_user_pb.GetEmailAddressReply;
  }
}
